import { loadScript } from '@mtfe/sweet-utils';
import { addGeoError, addGeoSuccess, addWebGeoPoint, GeoSource, getErrorMessage, handleErrorLog } from '@mtfe/sweet-report';

import guidFactory from './guidFactory';
import loadKNB from './loadKNB';

const LOCAL_STORAGE_KEY_4_GEO = 'local_storage_key_4_geo';

let _geoCache = null;
let _isError = false;

/**
 * 获取地理位置的参数
 */
const geoConfig = {
    project: 'offsiteact-v1',
    uuid: guidFactory.getPagePvId(),
    key: '42540830a42427ef5ca28f754d47716b',
    disable: [],
    maximumAge: 10000,
    enableHighAccuracy: false,
    KNBSceneToken: 'dj-004ceb0193ad4e58',
    geotype: 'GCJ02',
};

// 判断 localStorage 中的 LOCAL_STORAGE_KEY_4_GEO 是否过期
const isLocalStorageGeoExpired = () => {
    const tenMinutes = 1000 * 60 * 10; // 十分钟
    const localStorageCache = JSON.parse(window.localStorage.getItem(LOCAL_STORAGE_KEY_4_GEO) || '{}');

    // 检查缓存是否存在并且是否在有效期内
    if (localStorageCache && localStorageCache.expire) {
        return Date.now() - localStorageCache.expire >= tenMinutes;
    }
    // 如果缓存不存在或没有过期时间，则认为是过期的
    return true;
};

// 并行获取LBS信息
(async () => {
    const beginTime = Date.now();
    const getCurrentPosition = function () {
        window.webloc.getCurrentPosition(geoConfig, (err, result) => {
            const endTime = Date.now();
            const duration = endTime - beginTime;
            // 上报性能
            addWebGeoPoint(duration, result.geo);

            if (err) {
                _isError = true;
                handleErrorLog(err, { addErrorLog: false });
                // 上报定位异常
                addGeoError(GeoSource.webLocGeo, getErrorMessage(err));
                return;
            }
            // 上报定位成功
            addGeoSuccess(GeoSource.webLocGeo);
            _geoCache = {
                lat: result.geo.latitude,
                lon: result.geo.longitude,
                geoType: result.geo.geotype,
                geoSource: result.geo.source,
                geoAccuracy: result.geo.accuracy,
            };

            // 写入本地缓存
            window.localStorage.setItem(LOCAL_STORAGE_KEY_4_GEO, JSON.stringify({ expire: Date.now(), geoInfo: _geoCache }));
        });
    };

    const loadWeblocAndGetPosition = function () {
        if (!window.webloc) {
            loadScript('//s3.meituan.net/mnpm-cdn/@mtfe-mars-webloc-0.8.9/mars-webloc.umd.min.js', {}, function (err, script) {
                if (err) {
                    _isError = true;
                    handleErrorLog(err, { addErrorLog: false });
                    // 上报定位异常
                    addGeoError(GeoSource.webLocGeo, 'SDK(mars-webloc)获取异常');
                    return;
                }
                getCurrentPosition();
            });
        } else {
            getCurrentPosition();
        }
    };

    if (isLocalStorageGeoExpired()) {
        try {
            await loadKNB();
            loadWeblocAndGetPosition();
        } catch (error) {
            _isError = true;
            handleErrorLog(error, { addErrorLog: false });
            // 上报定位异常
            addGeoError(GeoSource.webLocGeo, 'SDK(knb)获取异常');
            return;
        }
    }
})();

const getLatLon = () => {
    return new Promise((resolve, reject) => {
        // 1、页面内多次调用getLatLon，非第一次不需要定位，不需要走localStorage，直接走内存
        if (_geoCache) {
            resolve(_geoCache);
            return;
        }

        // 2、内存中没有定位信息，从本地localStorage中拿
        if (!isLocalStorageGeoExpired()) {
            const localStorageCache = JSON.parse(window.localStorage.getItem(LOCAL_STORAGE_KEY_4_GEO) || '{}');
            // 十分钟
            resolve(localStorageCache.geoInfo);
            return;
        }

        // 3、内存、缓存没有定位信息，等待定位
        const timerId = setInterval(() => {
            if (_geoCache || _isError) {
                clearInterval(timerId);
                resolve(_geoCache);
            }
        }, 10);
    });
};

const GEO = {
    getLatLon,
};

export default GEO;
